import React, { Component } from 'react';
import { NavButton } from './ViewComponents';
import { HTMLTrans } from '../Common/Translations';
import { getLocalisedPath } from '../Common/Translations';
import { setLocaleCookie } from '../Locale/Locale'

const NavLangDropdown = (props) => {
    const {
        currentLanguage = {},
        languages = [],
        handleClick,
        isMobile = false
    } = props;

    const webDropDown = (
        <div className="dropdown nav__dropdown--border">
            <NavButton
                style={{ 'textDecorationLine': 'none' }}
                className="btn btn-link text-gray-darken-1 dropdown-toggle ml-0 d-flex align-items-center"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <div className="d-flex">
                    <img src="/img/svg/icon-language-globe.svg" className="pr-1" width="20" height="16" id="language-globe__img"/>
                    {currentLanguage.display_code}
                </div>
            </NavButton>
            <div className="dropdown-menu navigation-dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div className="dropdown-header ProximaNova"><HTMLTrans id="navbar.navlanguage_selectlanguage_title">Select your language</HTMLTrans></div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-item-container">
                    {languages.map(item => (
                        <div
                            key={item.code}
                            onClick={() => handleClick(item.code, item.is_default)}
                            className="dropdown-item ProximaNova"
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )

    const mobileDropdown = (
        <div className="d-flex align-items-center px-3 dropdown-btn-mobile" aria-labelledby="dropdownMenuButton">
            <img src="/img/svg/icon-language-globe.svg" id="language-globe-mobile__img"/>
            <select
                className="btn btn-link text-gray-darken-1"
                onChange={(event) => handleClick(event.target.value)}
                value={currentLanguage.code}
            >
                {languages.map(item => (
                    <option
                        key={item.code}
                        value={item.code}
                    >
                        {item.label}
                    </option>
                ))}
            </select>
        </div>
    );

    return (
        isMobile ? mobileDropdown : webDropDown
    );
}

const handleSelection = (langCode, isDefault) => {
    setLocaleCookie(langCode);
    const path = getLocalisedPath(langCode, isDefault);
    window.location.assign(window.location.origin + "/" + path);
}

const getPathArray = () => {
    return window.location.pathname.split('/').slice(1);
}

const handleLanguageSelection = (WrappedComponent) => {
    return (props) => {
        const selectedLanguage = props.languages.filter(l => l.code === getPathArray()[0])[0];
        const defaultLanguage = props.languages.find(l => l.is_default == 1);
        const currentLanguage = selectedLanguage || defaultLanguage;
        return (
            <WrappedComponent currentLanguage={currentLanguage} handleClick={handleSelection} {...props} />
        );
    }
};

export const LanguageSelector = handleLanguageSelection(NavLangDropdown);



// WEBPACK FOOTER //
// ./src/Nav/NavLanguage.js